module.exports = __webpack_public_path__ + "img/meisan_roulette_anime.457b676f.gif";